import { render } from "./nosto-pagination.vue?vue&type=template&id=410418fc"
import script from "./nosto-pagination.vue?vue&type=script&lang=js"
export * from "./nosto-pagination.vue?vue&type=script&lang=js"

import "./nosto-pagination.vue?vue&type=style&index=0&id=410418fc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__